"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
const baseSizes = {
    size0: 0,
    size13: 1,
    size25: 2,
    size50: 4,
    size100: 8,
    size200: 16,
    size300: 24,
    size400: 32,
    size500: 40,
    size600: 48,
    size700: 56,
    size800: 64,
    size900: 72,
    size1000: 80,
    size1100: 88,
    size1200: 96
};
const aliases = {
    iconSmall: baseSizes.size200,
    iconMedium: baseSizes.size400,
    iconLarge: baseSizes.size800
};
exports.sizes = {
    ...baseSizes,
    ...aliases
};
